import { IContentSource } from "../../../base/domain/drawing";
import { Company } from "../../../documaker/domain/format";
import { NameSpecifiedEntity } from "../../../base/domain/entity";

export class EditableFormatSummary extends NameSpecifiedEntity<number> {
  constructor(
    id: number,
    name: string,
    public readonly edition: number,
    public readonly version: string,
    public readonly isTemporary: boolean,
    public readonly lastUpdateDateTime: Date,
    public readonly lastUpdatedUserName: string,
    public readonly previewSource: IContentSource,
    public readonly thumbnailSource: IContentSource,
    public readonly reportTypeId: number = null,
    public readonly masterCode: string = null,
    public readonly tag: string = null,
    public readonly company: Company = null,
    public readonly categoryType: string = null,
    public readonly writeMethodType: string = null,
    public readonly startDateTime: Date = null,
    public readonly endDateTime: Date = null,
    public readonly deleted: boolean = false,
    public readonly archiveId: number = null,
    public readonly sort: number = null,
  ) {
    super(id, name);
  }

  clone() {
    return new EditableFormatSummary(
      this.id,
      this.name,
      this.edition,
      this.version,
      this.isTemporary,
      this.lastUpdateDateTime,
      this.lastUpdatedUserName,
      this.previewSource ? this.previewSource.clone() : null,
      this.thumbnailSource ? this.thumbnailSource.clone() : null,
      this.reportTypeId,
      this.masterCode,
      this.tag,
      this.company ? this.company.clone() : null,
      this.categoryType,
      this.writeMethodType,
      this.startDateTime,
      this.endDateTime,
      this.deleted,
      this.archiveId,
      this.sort,
    );
  }
}
